import { render } from "./PaasCoordsChart.vue?vue&type=template&id=41374626"
import script from "./PaasCoordsChart.vue?vue&type=script&lang=js"
export * from "./PaasCoordsChart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__